import {
  Button,
  ButtonGroup,
  Modal,
  ModalIcon,
  Spacer,
  Stack,
  TextBody,
  TextTitle,
} from '@pypestream/design-system';
import { TranslationComponent, useTranslation } from '@pypestream/translations';
import { FC } from 'react';

interface DeleteTeamConfirmationModalProps {
  open: boolean;
  isDeletingTeam: boolean;
  onClose: () => void;
  onDelete: () => void;
  teamName: string;
}

export const DeleteTeamConfirmationModal: FC<
  DeleteTeamConfirmationModalProps
> = ({ open, isDeletingTeam, onClose, onDelete, teamName }) => {
  const [t] = useTranslation();

  return (
    <Modal open={open} onClose={onClose}>
      <Stack
        justifyContent="center"
        alignItems="center"
        slot="header"
        style={{ textAlign: 'center' }}
      >
        <ModalIcon name="error" style={{ margin: 0 }} />
      </Stack>
      <TextTitle size="small" textAlign="center">
        {t('manager/teams:teamDetails.deleteTeamModal.mainTitle', {
          defaultValue: 'Delete team {{teamName}}?',
          teamName,
        })}
      </TextTitle>
      <Spacer size="small" />
      <TextBody variant="secondary">
        <div style={{ textAlign: 'center' }}>
          {t('manager/teams:teamDetails.deleteTeamModal.subTitle', {
            defaultValue: 'Deleting {{teamName}} will:',
            teamName,
          })}
        </div>
        <ul
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '80%',
            justifySelf: 'center',
          }}
        >
          <li>
            <TranslationComponent i18nKey="manager/teams:teamDetails.deleteTeamModal.line1">
              Remove inherited roles from all users in this team
            </TranslationComponent>
          </li>
          <li>
            <TranslationComponent i18nKey="manager/teams:teamDetails.deleteTeamModal.line2">
              Delete any linked teams in associated Contact Center instances
            </TranslationComponent>
          </li>
        </ul>
      </TextBody>
      <ButtonGroup align="center" slot="footer">
        <Button
          variant="secondary"
          size="large"
          width="full"
          onClick={() => {
            onClose();
          }}
          disabled={isDeletingTeam}
        >
          <TranslationComponent i18nKey="manager/teams:teamDetails.deleteTeamModal.cancel">
            Cancel
          </TranslationComponent>
        </Button>
        <Button
          variant="danger"
          size="large"
          width="full"
          onClick={() => {
            onDelete();
          }}
          disabled={isDeletingTeam}
        >
          {isDeletingTeam ? (
            <TranslationComponent i18nKey="manager/teams:teamDetails.deleteTeamModal.deleting">
              Deleting...
            </TranslationComponent>
          ) : (
            <TranslationComponent i18nKey="manager/teams:teamDetails.deleteTeamModal.delete">
              Delete
            </TranslationComponent>
          )}
        </Button>
      </ButtonGroup>
    </Modal>
  );
};
